var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "signup-frontiermiles-container" }, [
    _c("div", { staticClass: "signup-frontiermiles-logo" }, [
      _c("img", {
        attrs: {
          src: _vm.cdnHost + "/images/FrontierMileslogo.svg",
          alt: "Frontier Miles"
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "signup-p" }, [
      _vm._v("Join our free loyalty program and start earning today!")
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "signup-legend text-small" },
      [
        _c(
          "f9link",
          {
            attrs: {
              href: "https://www.flyfrontier.com/frontiermiles",
              target: "_blank"
            }
          },
          [_vm._v("Learn More")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "signup-info signup-images" }, [
      _c("div", { staticClass: "signup-image" }, [
        _c("img", {
          attrs: { src: _vm.cdnHost + "/images/Icon_RGBMarkers.svg", alt: "" }
        }),
        _vm._v(" "),
        _vm._m(1)
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "signup-image" }, [
        _c("img", {
          attrs: {
            src: _vm.cdnHost + "/images/Icon_BluebackgroundStar.svg",
            alt: ""
          }
        }),
        _vm._v(" "),
        _vm._m(2)
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "signup-image" }, [
        _c("img", {
          attrs: { src: _vm.cdnHost + "/images/Icon_GreenPlane.svg", alt: "" }
        }),
        _vm._v(" "),
        _vm._m(3)
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "signup-info-header green-background" }, [
      _c("div", [
        _c("strong", [_vm._v("Earn FREE Flights, Bags, Seats & More!")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "signup-images-text-container" }, [
      _c("span", { staticClass: "signup-images-large-text" }, [
        _vm._v("Earn 10X miles")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "signup-images-small-text" }, [
        _vm._v(
          "Earn 10X qualifying miles for every eligible dollar spent with Frontier, up to 20X miles for "
        ),
        _c("i", [_vm._v("FRONTIER Miles")]),
        _vm._v(" Diamond members.")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "signup-images-text-container" }, [
      _c("span", { staticClass: "signup-images-large-text" }, [
        _vm._v("Easy-to-get Status")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "signup-images-small-text" }, [
        _vm._v(
          "Get Elite Status with only 10,000 qualifying miles, or $1,000 on any Frontier purchase!"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "signup-images-text-container" }, [
      _c("span", { staticClass: "signup-images-large-text" }, [
        _vm._v("Get FREE Flights")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "signup-images-small-text" }, [
        _vm._v(
          "A FREE one-way award ticket starts at just 10,000 miles! Now you can get free flights faster with more ways to earn."
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e16d207e", { render: render, staticRenderFns: staticRenderFns })
  }
}